import React from "react"

import WorkCard from './WorkCard';
import styles from './work.module.css';
import Icon from './Icon';

// import { Modal, Icon } from 'antd';

import icon from './Icon';

import Modal from 'react-modal';

const customStyles = {
  overlay: {
    background            : 'rgba(0,0,0, .4)',
  },
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    maxWidth              : '90%',
    maxHeight             : '500PX'
  }
};


class Work extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      project: props.projects[0],
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal(project) {
    this.setState({modalOpen: true, project});
  }

  closeModal() {
    this.setState({modalOpen: false})
  }

  render() {

    return (
      <div className="fullSection">

      <Modal
        isOpen={this.state.modalOpen}
        onRequestClose={this.closeModal}
        style={customStyles}
      >

        <div className={styles.modalContent}>

          <div className={styles.title}>
            {this.state.project.name}
          </div>

          <div className={styles.contenty}>

            <div className={styles.modalImageWrapper}>
              <img className={styles.workImage} src={this.state.project.image} alt="gif" />
            </div>

            <div className={styles.modalLinks}>
              <div className={styles.modalLink}>
                  <a href={this.state.project.ghLink}>
                    <Icon type="github"/> Github
                  </a>
              </div>

              { this.state.project.liveLink &&
               <div className={styles.modalLink}>
                  <a href={this.state.project.liveLink}>
                    <Icon type="lightening"/> live site
                  </a>
              </div>}

            </div>


          </div>
          <div className={styles.modalDescription}>
            {this.state.project.description}
          </div>
        </div>

      </Modal>

        <div className={styles.gridWrapper}>
          {
            this.props.projects.map(project => <WorkCard
              onClick={this.openModal}
              name={project.name}
              liveLink={project.liveLink}
              ghLink={project.ghLink}
              image={project.image}
              description={project.description}
              tags={project.tags}
            />)
          }
        </div>
      </div>
    )
  }

}

export default Work
